import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultarCumplimientosFormComponent } from '../consultar-cumplimientos-form.component';

/**
 * Orientaciones Programadas - Consulta de cumplimientos rechazados.
 * Legacy: FilterCumplimProgViewImpl
 * Reutiliza el formulario compartido con tipo='PROGRAMADA'
 */
@Component({
  selector: 'app-orientaciones-programadas',
  standalone: true,
  imports: [CommonModule, ConsultarCumplimientosFormComponent],
  template: `
    <div>
      <h2 class="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-4">
        Orientaciones Programadas
      </h2>
      <app-consultar-cumplimientos-form tipo="PROGRAMADA" />
    </div>
  `
})
export class OrientacionesProgramadasComponent {}
